module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_resort@3x-fd18fb3ee6240447143096710a648d09.webp";